import styles from "./about.module.css";
import { aboutImage1, aboutImage2, aboutImage3, aboutImage4 } from "@/assets/images";

/**
 * About Component
 * About Andy section with feature cards
 */
export const About = () => {
  return (
    <section id="about" className={styles.aboutSection}>
      <div className={styles.aboutContent}>
        <h2 className={styles.aboutTitle}>
          <span className={styles.aboutLabel}>About</span>{" "}
          <span className={styles.andyLabel}>Andy</span>
        </h2>
        <p className={styles.aboutSubtitle}>Your Smart Partner for Property Tax Fairness.</p>

        <div className={styles.featureCards}>
          <div className={styles.featureCard}>
            <div className={styles.iconContainer}>
              <img src={aboutImage1} alt="About Andy" />
            </div>
            <h3 className={styles.cardTitle}>Virtual Tax Advisor</h3>
            <p className={styles.cardDescription}>
              Helps homeowners review, challenge property tax assessments.
            </p>
          </div>

          <div className={styles.featureCard}>
            <div className={styles.iconContainer}>
              <img src={aboutImage2} alt="About Andy" />
            </div>
            <h3 className={styles.cardTitle}>No Hassle Process</h3>
            <p className={styles.cardDescription}>
              No paperwork, no agents, no confusion, no time waste.
            </p>
          </div>

          <div className={styles.featureCard}>
            <div className={styles.iconContainer}>
              <img src={aboutImage3} alt="About Andy" />
            </div>
            <h3 className={styles.cardTitle}>Clear & Guided</h3>
            <p className={styles.cardDescription}>
              Simple steps with easy-to-understand insights to protest your property.
            </p>
          </div>

          <div className={styles.featureCard}>
            <div className={styles.iconContainer}>
              <img src={aboutImage4} alt="About Andy" />
            </div>
            <h3 className={styles.cardTitle}>Expert + Smart Tech</h3>
            <p className={styles.cardDescription}>
              Powered by tax expertise Driven by intelligent analysis Built for decisions.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
